module.exports = __webpack_public_path__ + "static/media/pathways-robot-2_orig.cd0a241b.png";